import { useState } from "react"
import { Card, Button, Modal, CloseButton, Spinner } from 'react-bootstrap';
import DataGrid from '../../controls/DataGrid.js/DataGrid'
import { useSelector } from 'react-redux';
import SpendingPlanCategoryForm from './SpendingPlanCategoryForm';
import Icon from "../../controls/Icons/Icon";
import useFetchWithCancellation from "../../../customhooks/useFetchWithCancellation";
import { ErrorBoundary } from 'react-error-boundary';
import ErrorHandler from "../../controls/ErrorHandler";

const SpendingPlanCategory = () => {
    const { fetchData } = useFetchWithCancellation();
    const state = useSelector(state => state);
    const [refreshGrid, setRefreshGrid] = useState(false);
    const [loading, setLoading] = useState(false);
    const [inputValue, setInputValue] = useState({
    });
    const columns = [
        {
            field: "ServiceName",
            title: "Service Name",
            sortName: "ServiceName",
            sortable: true,
        },
        {
            field: "ServiceCode",
            title: "Service Code",
            sortName: "ServiceCode",
            sortable: true,
        },
        {
            field: "spCategory.CategoryName",
            title: "Service Category",
            sortName: "spCategory.CategoryName",
            sortable: true,
        },  
        {
            dataField: "remove",
            title: "",
            text: "Delete",
            formatter: (cellContent, row) => {
                return (<div>
                    {state.access.edit ? <Button
                        className="btn-xs me-2 mb-2 p-0" variant="link"
                        onClick={() => handleEdit(row)}
                    ><Icon name="BsPencilFill" className='fs-5' /></Button> : ""}

                    {state.access.delete ? <Button variant="link"
                        className="btn-xs mb-2 p-0"
                        onClick={() => handleDelete(row)}
                    >
                        <Icon name="BsTrash" className='fs-5' />
                    </Button> : ""}
                </div>
                );
            },
        }
    ];

    const handleEdit = (res) => {
        setInputValue(res)
        setShowModal(true)
    };

    const handleDelete = ((res) => {
        window.confirm("Do you want to delete the SP Category?", function () {
            setLoading(true);
            fetchData(state.projectdetail.API + "/SPCategoryDetail/delete?Id=" + res.Id, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
            }).then(response => response.json()).then((res) => {
                if (res.Succeeded) {
                    window.alert("Deleted successfuly");
                    setRefreshGrid(!refreshGrid);
                }
                else {
                    window.alert(res.Message, function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                }
            }).catch((err) => {
                if (err && err.name === 'AbortError') return;
                window.HandleError("SpendingPlanCategory.js ==> handleDelete", null, null, err);
                window.alert(state.projectdetail.ErrorMessage);
            }).finally(() => {
                setLoading(false);
            });
        })

    });

    const options = {
        dataType: "server",
        showExport: true,
        showRefresh: true,
        sortName: "firstName",
        sortOrder: "asc",
    };
    const [showModal, setShowModal] = useState(false);
    const handleClose = () => setShowModal(false);
    const handleAdd = () => {
        setInputValue([])
        setShowModal(true)
    };
    const handleAfter = (res) => {
        if (res.Succeeded) {
            window.alert("SP Category saved successfully");
            handleClose();
            setRefreshGrid(!refreshGrid);
        }
        else {
            window.alert(res.Message, function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
        }
    };
    return (
        <ErrorBoundary FallbackComponent={ErrorHandler}>
            <h4 className='form-heading mb-4'>
                Spending Plan Category
                <div className='d-inline-block float-end'>
                    {state.access.add && <Button onClick={handleAdd}>Add New Spending Plan Category</Button>}&nbsp;
                </div>
            </h4>
            <Card>
                <Card.Body>
                    {loading ? <div className="text-center"><Spinner as="span" animation="border" size="lg" role="status" aria-hidden="true" /> </div> : ""}
                    <DataGrid url={state.projectdetail.API + "/SPCategoryDetail/grid"} classes="table table-striped" options={options} columns={columns} refresh={refreshGrid} />
                </Card.Body>
            </Card>
            <Modal show={showModal} onHide={handleClose} size="lg" backdrop="static">
                <Modal.Header>
                    <h4>{inputValue.Id ? "Edit " : "Add "} Spending Plan Category</h4>
                    <CloseButton onClick={handleClose} className="btn-close" />
                </Modal.Header>
                <Modal.Body>
                    <SpendingPlanCategoryForm afterSave={handleAfter} _inputValue={inputValue}  onCancel={handleClose} />
                </Modal.Body>
            </Modal>
        </ErrorBoundary>
    );
}
export default (SpendingPlanCategory);
